// Modules
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// Assets
import ThinArrowRight from "../../../assets/svg/thinArrowRight";

// Components
import FormattedLink from "../link"; // Ensure you import the correct component

// Styles
import * as styles from "./breadcrumbs.module.scss";
import COLORS from "../../constants/colors";

const Breadcrumbs = ({ links, className }) => {
  const breadcrumbsClassName = cx(className ?? styles.breadcrumbs);

  return (
    <div className={breadcrumbsClassName}>
      {(links ?? []).map(({ _key, url, label }, i) => {
        const isLast = i + 1 === links.length;
        if (isLast) {
          return (
            <div className={styles.h4} key={_key} style={{ display: 'inline-block' }}>
              {label}
            </div>
          );
        }
        return (
          <FormattedLink key={_key} url={url}>
            <span>{label}</span>
            <ThinArrowRight fill={COLORS.pink} />
          </FormattedLink>
        );
      })}
    </div>
  );
};

Breadcrumbs.propTypes = {
  links: PropTypes.array,
  className: PropTypes.string,
};

Breadcrumbs.defaultProps = {
  links: [],
  className: undefined,
};

export default Breadcrumbs;
